import React from 'react';
import { Route } from 'react-router-dom';
import { obtenerComponente, esComponenteDisponible } from './registroComponentes';
import { REGISTRO_COMPONENTES } from './registroComponentes';

// Almacenamiento de rutas generadas para monitoreo
let rutasGeneradasCache = [];

/**
 * Genera rutas dinámicamente desde los items del menú
 * @param {Array} menuItems - Items del menú obtenidos de la base de datos
 * @param {Object} commonProps - Props comunes a pasar a todos los componentes
 * @returns {Array} - Array de componentes Route
 */
export function generarRutasDesdeMenu(menuItems, commonProps = {}) {
  
  const routes = [];
  const rutasInfo = []; // Para el cache de monitoreo
  
  function procesarItemsMenu(items) {
    items.forEach(item => {
      // Solo procesar items que tienen URL válida, están activos/visibles y tienen componente disponible
      if (item.url && 
          item.url !== '/**' && item.url !== '/***' && 
          esComponenteDisponible(item.url) &&
          (item.activo !== false) &&  // Permitir undefined o true
          (item.visible !== false)) { // Permitir undefined o true
        
        const Component = obtenerComponente(item.url);
        
        if (Component) {
          // Props especiales para AdminRutas y Menus (gestión de menús)
          const componentProps = { ...commonProps };
          if ((item.url === '/sistema/admin-rutas' || item.url === '/menus') && commonProps.onRefreshMenu) {
            componentProps.onRefreshMenu = commonProps.onRefreshMenu;
          }
          
          // Pasar condiciones del menú a los componentes
          // IMPORTANTE: Siempre pasar, incluso si están vacías
          componentProps.condiciones = item.condiciones || '';
          componentProps.condicionesHijos = item.condicionesHijos || [];
          
          routes.push(
            <Route
              key={item.url}
		path={item.url}
		exact
              render={props => (
                <Component 
                  {...props} 
                  {...componentProps}
                />
              )}
            />
          );
          
          // Agregar al cache para monitoreo
          rutasInfo.push({
            url: item.url,
            nombre: item.nombre,
            componente: Component.name || 'Anónimo',
            activo: item.activo,
            visible: item.visible
          });
          
        }
      } else if (item.url && 
                 item.url !== '/**' && item.url !== '/***' && 
                 !esComponenteDisponible(item.url)) {
        console.warn(`[Ruta Inválida] ${item.url} - ${item.nombre} - Componente no encontrado`);
      }
      
      // Procesar subitems recursivamente si existen
      if (item.items && Array.isArray(item.items)) {
        procesarItemsMenu(item.items);
      }
    });
  }
  
  // Validar que menuItems existe y es array antes de procesar
  if (!menuItems || !Array.isArray(menuItems)) {
    return routes;
  }
  
  procesarItemsMenu(menuItems);
  
  // Actualizar cache para monitoreo
  rutasGeneradasCache = rutasInfo;
  
 
  return routes;
}

/**
 * Valida si un menú tiene componentes disponibles
 * @param {Array} menuItems - Items del menú
 * @returns {Object} - Estadísticas de validación
 */
export function validarMenuItems(menuItems) {
  const estadisticas = {
    total: 0,
    validas: 0,
    invalidas: 0,
    itemsInvalidos: []
  };
  
  function validarItems(items) {
    items.forEach(item => {
      if (item.url && item.url !== '/**' && item.url !== '/***') {
        estadisticas.total++;
        
        if (esComponenteDisponible(item.url)) {
          estadisticas.validas++;
        } else {
          estadisticas.invalidas++;
          estadisticas.itemsInvalidos.push({
            nombre: item.nombre,
            url: item.url,
            id: item.id
          });
        }
      }
      
      if (item.items && Array.isArray(item.items)) {
        validarItems(item.items);
      }
    });
  }
  
  validarItems(menuItems);
  return estadisticas;
}

/**
 * Obtiene URLs de menú que no tienen componente disponible
 * @param {Array} menuItems - Items del menú
 * @returns {Array} - URLs sin componente
 */
export function obtenerURLsSinComponente(menuItems) {
  const urlsSinComponente = [];
  
  function buscarURLs(items) {
    items.forEach(item => {
      if (item.url && item.url !== '/**' && item.url !== '/***' && 
          !esComponenteDisponible(item.url)) {
        urlsSinComponente.push({
          nombre: item.nombre,
          url: item.url,
          padre: item.padre || null
        });
      }
      
      if (item.items && Array.isArray(item.items)) {
        buscarURLs(item.items);
      }
    });
  }
  
  buscarURLs(menuItems);
  return urlsSinComponente;
}

// Funciones auxiliares para el sistema de monitoreo
export const obtenerRutasDisponibles = () => {
  return rutasGeneradasCache;
};

export const obtenerComponentesRegistrados = () => {
  return REGISTRO_COMPONENTES;
};

export default generarRutasDesdeMenu;
